import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { rootActions } from "../../actions/rootActions";
import { thanhPhanThiApi } from "../../../api/category/thanhPhanThiApi";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eThanhPhanThiActionIds, IThanhPhanThiActionTypes } from "../../action-types/category/IThanhPhanThiActions";
import { IThanhPhanThi } from "../../../model/response/category/IThanhPhanThi";

const mainAction = rootActions.category.thanhPhanThi;
export function* thanhPhanThiSaga(): any {
    yield takeLatest(eThanhPhanThiActionIds.LOAD_START, loadWorker);
    yield takeEvery(eThanhPhanThiActionIds.SAVE_START, saveWorker);
     yield takeEvery(eThanhPhanThiActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
    const res: IBaseResponse = yield call(thanhPhanThiApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* saveWorker(action: IThanhPhanThiActionTypes): any {
   let res: IBaseResponse;
   const payload = action.payload as IThanhPhanThi;
   if (payload.id_thanh_phan_thi > 0) {
       res = yield call(thanhPhanThiApi.Update, payload.id_thanh_phan_thi, payload);      
   } else {
         res = yield call(thanhPhanThiApi.Insert, payload);
    }
    if (res.is_success) {
     yield put(mainAction.SAVE_SUCCESS(toLowerCaseDeep(res.data)));
    }
    else {
     yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* deleteWorker(action: IThanhPhanThiActionTypes): any {
    const id= action.payload as number;
    const res: IBaseResponse = yield call(thanhPhanThiApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"));
    }
}

